// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"4a304a74","23":"cfe67d1e","87":"3b7bbf0e","121":"f3781906","163":"65aa1d53","251":"1a4ffae7","256":"25a4a499","460":"e92cc32f","616":"adfe0a3e","693":"095fbacb","767":"d9224403"}[chunkId] + ".chunk.js";
};